function initNavContact() {

	var navContactContainer = $('.nav-contact-container');
	var navContact = $('.nav-contact');
	var navContactOverlay = $('.nav-contact-overlay');

	navContact.on('click', function () {
		if(!navContactContainer.hasClass('open')){
			navContactContainer.addClass('open');
			navContactOverlay.addClass('appear');
		}
	});

	navContactOverlay.on('click', function () {
		if(navContactContainer.hasClass('open')){
			navContactOverlay.removeClass('appear');
			navContactContainer.removeClass('open');
		}
	});

	resizeNavContact();
}

function resizeNavContact() {
	/*if (window.innerWidth > 1200) {
		$('.nav-contact').css({
			top: $('.nav-main').offset().top,
			height: $('.nav-main').height()
		});
	}
	else{
		$('.nav-contact').removeAttr('style');
	}*/
}
